import React from 'react';

import { SketchPicker } from 'react-color';
import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Button, ButtonGroup, Menu, MenuItem, Tooltip } from '@mui/material';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import CancelIcon from '@mui/icons-material/Cancel';

const ColorButtons = ({
  hide = {},
  initFontColor = '#000000',
  initBackGround = 'transparent',
}) => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    background,
    fontColor,
  } = useNode(({ data: { props } }) => {
    return {
      background: props.background,
      fontColor: props.fontColor,
    };
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl?.elRef);

  const onClick = (event) => {
    setAnchorEl({ elRef: event.currentTarget, name: event.currentTarget.name });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFontColor = (color, name) => {
    let fieldName = '';

    if (name === 'textColor') {
      fieldName = 'fontColor';
    }
    if (name === 'backgroundColor') {
      fieldName = 'background';
    }
    if (fieldName)
      setProp((props) => {
        props[fieldName] = color.hex;
      }, 500);
  };

  const onRemoveClick = () => {
    setProp((props) => {
      props.fontColor = initFontColor;
      props.background = initBackGround;
    }, 500);
  };

  return (
    <>
      <ButtonGroup
        disableElevation
        sx={{ border: 'none', borderRadius: '3px' }}
        aria-label='Basic button group'
        size='small'
      >
        {!hide?.textColor && (
          <Tooltip title={t('text_color')}>
            <Button
              name='textColor'
              onClick={onClick}
              id='basic-button'
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              sx={(theme) => ({
                p: 1,
                '& span': {
                  m: 0,
                },
                backgroundColor: theme.palette.secondary.light,
                color: theme.common.buttonInactive,
                border: `none`,
              })}
              startIcon={<BorderColorIcon />}
            />
          </Tooltip>
        )}
        {!hide?.backgroundColor && (
          <Tooltip title={t('background_color')}>
            <Button
              name='backgroundColor'
              onClick={onClick}
              sx={(theme) => ({
                p: 1,
                '& span': {
                  m: 0,
                },
                backgroundColor: theme.palette.secondary.light,
                color: theme.common.buttonInactive,
                border: `none`,
              })}
              startIcon={<ColorLensIcon />}
            />
          </Tooltip>
        )}

        <Tooltip title={t('reset_color')}>
          <Button
            onClick={onRemoveClick}
            sx={(theme) => ({
              p: 1,
              '& span': {
                m: 0,
              },
              backgroundColor: theme.palette.secondary.light,
              color: theme.common.buttonInactive,
              border: `none`,
            })}
            startIcon={<CancelIcon />}
          />
        </Tooltip>
      </ButtonGroup>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl?.elRef}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem>
          <SketchPicker
            label={t('background')}
            color={anchorEl?.name === 'textColor' ? fontColor : background}
            // eslint-disable-next-line no-param-reassign
            onChangeComplete={(col) => handleFontColor(col, anchorEl?.name)}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ColorButtons;
